import API from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IResponse, IPKDetail } from '@umu/umu-types';

// 获取课程PK团队信息
export const getCoursePKInfo = async (id: string): Promise<IResponse<IPKDetail>> => {
    return await fetchData(API.GET_COURSE_PK_INFO, { id });
};
